import { IAppState } from '../../common/state';

export function getName({ newbuildingInformation }: IAppState): string | null {
  return newbuildingInformation?.name || null;
}
